<template lang="pug">
  section.section
    .container
      .columns.is-multiline
        card_LlenaderaIrge(v-for="llen in llenaderas" :llenadera="llen" :key="llen.id")
</template>


<script>
  import card_LlenaderaIrge from '@/components/estaciones_Componentes/layouts/card_LlenaderaIrge.vue'
  import sca_irgeServices from '@/services/sca/irge.js'
  
  export default {
    name: 'Llenaderas_IRGE',
    components: { card_LlenaderaIrge },
    props: {
      activo: {
        type: Boolean,
        default: false
      },
      permisos: {
        type: Number,
        default: 0
      },
    },
    data() {
      return {
        refresh: null,
        llenaderas: [],
        activarData: this.activo
      }
    },
    watch: {
      activo (active) {
        this.activarData = active 
        if (active) {
          this.iniciarComponente()
        } else {
          clearInterval(this.refresh)
        }
      }
    },
    methods: {
      obtenerDatosLlenaderas () {
        /* const comp = this.permisos == 10 ? 'mov' : '461df68c944e1f3784a733245d6b3dd1' 
          Se otorgan permisos a todos los usuarios para consulta de llenaderas
        */
        const comp = '461df68c944e1f3784a733245d6b3dd1'

        sca_irgeServices.getLlenaderas(comp)
          .then(res => {
            this.llenaderas = res
          })
      },
      iniciarComponente () {
        this.refresh = setInterval(() => {
          if (this.activarData) {
            this.obtenerDatosLlenaderas()
          } else {
            clearInterval(this.refresh)
          }
        }, 5000)
      },
    },
    beforeDestroy() {
      clearInterval(this.refresh)
    },
    created () {
      this.obtenerDatosLlenaderas()
      this.iniciarComponente()
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/estaciones_Componentes/Llenaderas_IRGE.vue